import { Trigger } from 'models/automation/Triggers';
import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import { AutomationsStyledTable } from '../Automations.styles';

export const TriggerConditionsContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;

  .condition-row {
    align-items: start;
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;

    .remove-condition {
      border: none;
    }
  }

  .condition-row__fields {
    align-items: start;
    display: flex;
    flex-direction: row;
    gap: 5px;

    ${mediaQuery.xs} {
      flex-wrap: wrap;
    }

    &.condition-row__fields--space-between {
      justify-content: space-between;
      width: 100%;
    }

    select,
    .basic-multi-select {
      min-width: 100px;
    }

    .form-field-container {
      margin-bottom: 0;

      > div {
        padding-left: 0;
        padding-right: 0;
      }
    }

    .select__dropdown-indicator {
      padding: 6px;
    }
  }

  .condition-help-text {
    margin-top: 7px;
  }
`;

export const TriggersTableStyled = styled(AutomationsStyledTable<Trigger>)`
  .body-cell-actions {
    button {
      padding: 6px;
      margin-top: 1px;
    }

    span:last-of-type button {
      margin-top: -2px;
    }
  }

  .body-cell-status {
    position: relative;

    > div {
      position: absolute;
      top: 0;
    }
  }

  .column-actions {
    width: 100px;
  }

  .column-status {
    width: 61px;
  }

  ${mediaQuery.xs} {
    .column-header-status,
    .body-cell-status {
      background-color: white;
      position: sticky;
      right: 0;
    }

    .column-header.column-header-actions,
    .body-cell.body-cell-actions {
      right: 61px;
    }
  }
`;
